import { type ChangeEvent, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { action } from "mobx";
import { observer } from "mobx-react";
import { Button, Box, TextField, Typography } from "@mui/material";
import { routes } from "@/router/Routes";
import { passwordHelperText } from "@/util/commonStrings";
import { interactionStore, authStore } from "@/stores/Stores";
import { Page } from "@/components/Page";

export const CreateNewPassword = observer(() => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const passwordInputRef1 = useRef<HTMLInputElement>(null);
  const passwordInputRef2 = useRef<HTMLInputElement>(null);

  const token = searchParams.get("token");
  const showError = Boolean(authStore.unknownUser.password) && !authStore.unknownUser.isPasswordValid;
  const showErrorConfirm = Boolean(authStore.unknownUser.password) && !authStore.unknownUser.arePassowrdsMatching;

  authStore.unknownUser.passwordResetCode = token || "";
  console.log(authStore.unknownUser.passwordResetCode);

  const onSubmitHandler = async (event: React.FormEvent<unknown>) => {
    event.preventDefault();

    if (passwordInputRef1.current?.value && passwordInputRef2.current?.value) {
      authStore.changePassword();
    }
  };

  return (
    <Page title="Create Password" showLanguages>
      <TextField
        inputRef={passwordInputRef1}
        onChange={action((event: ChangeEvent<HTMLInputElement>) => {
          authStore.unknownUser.password = event.target.value;
        })}
        fullWidth
        type="password"
        label={t("New Password")}
        variant="outlined"
        size="medium"
        error={showError}
        helperText={showError ? passwordHelperText : ""}
      />

      <TextField
        inputRef={passwordInputRef2}
        onChange={action((event: ChangeEvent<HTMLInputElement>) => {
          authStore.unknownUser.passwordAgain = event.target.value;
        })}
        fullWidth
        type="password"
        label={t("Enter New Password Again")}
        variant="outlined"
        size="medium"
        error={showErrorConfirm}
        helperText={showErrorConfirm ? t("Passwords do not match") : ""}
      />

      <Button
        disabled={!authStore.unknownUser.canCreateNewPassword || interactionStore.loading}
        fullWidth
        type="submit"
        variant="contained"
        color="primary"
        sx={{ marginTop: "1rem" }}
        onClick={onSubmitHandler}
      >
        {t("Change Password")}
      </Button>

      <Box sx={{ marginTop: "1rem" }}>
        <Typography variant="body2" style={{ marginTop: "2rem" }}>
          {t("Need an account?")} <Link to={routes.pages.signup}>{t("Register")}</Link>
        </Typography>
      </Box>
    </Page>
  );
});
